// Emoji icon per profile interest (the simple free-text INTERESTS list in
// types/user.ts — NOT the rich wizard/dating InterestCategory system). Consumed
// by InterestPillGrid to render icon pills. Any interest without a mapping falls
// back to INTEREST_ICON_FALLBACK.

export const INTEREST_ICON_FALLBACK = '✨';

export const INTEREST_ICONS: Record<string, string> = {
  Gaming: '🎮',
  Music: '🎵',
  Movies: '🎬',
  Travel: '✈️',
  Cooking: '🍳',
  Fitness: '💪',
  Reading: '📚',
  Art: '🎨',
  Photography: '📷',
  Dancing: '💃',
  Sports: '⚽',
  Technology: '💻',
  Nature: '🌿',
  Pets: '🐾',
  Fashion: '👗',
  Food: '🍜',
  Comedy: '😄',
  Adventure: '🧭',
};

/** Icon for an interest, with a graceful emoji fallback. */
export function interestIcon(interest: string): string {
  return INTEREST_ICONS[interest] ?? INTEREST_ICON_FALLBACK;
}
